import { render, staticRenderFns } from "./embedded-recording-registration.vue?vue&type=template&id=87b8355a&"
import script from "./embedded-recording-registration.vue?vue&type=script&lang=js&"
export * from "./embedded-recording-registration.vue?vue&type=script&lang=js&"
import style0 from "./embedded-recording-registration.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "embedded-recording-registration.vue"
export default component.exports